import {LISTABLE_TYPES, LISTABLE_TYPES_MODELS} from 'dicts/lists';
import * as buildingDicts from 'dicts/buildings';
import {getGoogleMapsAddress} from 'utils/maps';
/**
 * Get the building from a list item
 * @param {object} listItem
 * @param {string} itemType
 * @returns {object}
 */
export const getBuildingFromListable = (listItem, itemType) => {
	switch (itemType) {
		case LISTABLE_TYPES.buildings:
			return listItem;
		case LISTABLE_TYPES.clients:
			return listItem?.building?.data;
		case LISTABLE_TYPES.leads:
			return listItem?.building?.data;
		case LISTABLE_TYPES.projects:
			return listItem?.buildings?.data?.[0] ?? null;
		default:
			return null;
	}
};

/**
 * Get the building from a list item
 * @param {object} listItem
 * @returns {object}
 */
export const getListItemBuilding = listItem => {
	const type = LISTABLE_TYPES_MODELS[listItem.listableType];
	switch (type) {
		case LISTABLE_TYPES.buildings:
			return listItem?.listable?.data ?? null;
		case LISTABLE_TYPES.clients:
			return listItem?.listable?.data?.building?.data ?? null;
		case LISTABLE_TYPES.leads:
			return listItem?.listable?.data?.building?.data ?? null;
		case LISTABLE_TYPES.projects:
			return listItem?.listable?.data?.buildings?.data?.[0] ?? null;
		default:
			return null;
	}
};

/**
 * Get the client from a list item
 * @param {object} listItem
 * @returns {object}
 */
export const getListItemClient = listItem => {
	const type = LISTABLE_TYPES_MODELS[listItem.listableType];
	if (type === LISTABLE_TYPES.buildings) {
		if (Array.isArray(listItem?.listable?.data?.clients?.data)) {
			return listItem?.listable?.data?.clients?.data[0] ?? null;
		}
		return null;
	} else if (type === LISTABLE_TYPES.clients) {
		return listItem?.listable?.data ?? null;
	} else if (type === LISTABLE_TYPES.leads) {
		return listItem?.listable?.data?.client?.data ?? null;
	} else if (type === LISTABLE_TYPES.projects) {
		return listItem?.listable?.data?.clients?.data?.[0] ?? null;
	}
	return null;
};

/**
 * Get the lead from a list item
 * @param {object} listItem
 * @returns {object}
 */
export const getListItemLead = listItem => {
	const type = LISTABLE_TYPES_MODELS[listItem.listableType];
	if (type === LISTABLE_TYPES.leads) {
		return listItem?.listable?.data ?? null;
	}
	return null;
};

/**
 * Get the project from a list item
 * @param {object} listItem
 * @returns {object}
 */
export const getListItemProject = listItem => {
	const type = LISTABLE_TYPES_MODELS[listItem.listableType];
	if (type === LISTABLE_TYPES.projects) {
		return listItem?.listable?.data ?? null;
	}
	return null;
};

/**
 * Get the building map address
 * @param {object} building
 * @returns {string}
 */
export const getBuildingMapAddress = building => {
	try {
		return getGoogleMapsAddress(building);
	} catch (error) {
		return null;
	}
};

/**
 * Get a message id based on the product state.
 * @param {string} val
 * @returns {string}
 */
// TODO: REN-952 - getProductStateLabel({intl, value})
export const getMessageIdForProductState = val => {
	switch (val) {
		case 'takeContact':
			return 'Not done';
		case 'installed':
			return 'Done';
		default:
			return buildingDicts.encounterState[val];
	}
};
